import { setDateTime2 } from '@/utils/date_util';
import { providerorderpage, providerorderpageExpage, updatebatchAddress } from '@/api/logisticsOrders/index.js';
import { batchPdfDownload } from '@/utils/PDF_util';
import { CustomerPage } from '@/api/customer';
import { cloneDeep } from 'lodash-es';
import { saveAs } from 'file-saver';
import { headerList, tableHeaderForm } from './tableHeadListData/index';
import dayjs from 'dayjs';
import { getStartupProviderChannel } from '@/api/channelManage';
import { addressPage } from '@/api/orderApi';
import { goResourceTaskList } from '@/utils/goExportList';
export default {
  getTimer() {
    // const day = new Date();
    // const brazilTime = day.toLocaleString('en-US', { timeZone: 'America/Sao_Paulo' });
    const today = dayjs().format('YYYY-MM-DD');
    // const oneWeekAgo = dayjs().subtract(6, 'day').format('YYYY-MM-DD');
    this.timeValue = [today + ' 00:00:00', today + ' 23:59:59'];
  },
  resetData() {
    // 使用默认值重置 queryForm
    const defaultParams = {
      searchTimeType: '1',
      providerOrderStatus: '',
      searchNumberType: '1',
      providerId: '',
      customerId: '',
      searchNumberStr: '',
      merchantName: '',
      merchantCode: ''
    };
    this.getTimer();
    this.queryForm = {
      pageSize: 10,
      pageNumber: 1,
      params: {
        ...defaultParams
      }
    };
    this.getSearch();
  },
  enterGetSearch() {
    this.queryForm.pageNumber = 1;
    this.getSearch();
  },
  getSearch() {
    const data = {
      pageNumber: this.queryForm.pageNumber,
      pageSize: this.queryForm.pageSize,
      params: {
        providerOrderStatus: this.queryForm.params.providerOrderStatus || null,
        providerId: this.queryForm.params.providerId || null,
        customerId: this.queryForm.params.customerId || null,
        waybillNumberList: [],
        customerNumberList: [],
        providerNumberList: [],
        createEndTime: '',
        createStartTime: '',
        merchantName: this.queryForm.params.merchantName,
        merchantCode: this.queryForm.params.merchantCode
      }
    };
    if (this.queryForm.params.searchNumberStr) {
      if (this.queryForm.params.searchNumberType === '1') {
        data.params.waybillNumberList = this.queryForm.params.searchNumberStr.split('\n');
      } else if (this.queryForm.params.searchNumberType === '2') {
        data.params.customerNumberList = this.queryForm.params.searchNumberStr.split('\n');
      } else if (this.queryForm.params.searchNumberType === '4') {
        data.params.scanNumberList = this.queryForm.params.searchNumberStr.split('\n');
      } else {
        data.params.providerNumberList = this.queryForm.params.searchNumberStr.split('\n');
      }
    }
    if (this.timeValue && this.timeValue.length > 0) {
      data.params.createStartTime = this.timeValue[0];
      data.params.createEndTime = this.timeValue[1];
    } else {
      // ① 字段：当“订单状态”等于：取号失败时，订单创建时间允许为空，即不需要填写时间就可以查询
      if (!this.queryForm.params.searchNumberStr && this.queryForm.params.providerOrderStatus !== 4) {
        this.$message.warning(this.$t('collectionCenter.PleaseSelectTime'));
        return;
      }
    }
    this.exportParam = cloneDeep(data);
    providerorderpage(data).then(res => {
      if (res.status === 'OK') {
        this.queryForm.total = res.data.total;
        this.tableData = res.data.records;
        this.$refs.anjunTable.toggleSelection();
        this.tableData.forEach((item) => {
          item['checkTrajectory1'] = true;
        });
      }
    });
  },
  getCustomerList() {
    const param = {
      pageNumber: 1,
      pageSize: 9999999,
      params: {}
    };
    CustomerPage(param).then((res) => {
      if (res.status === 'OK') {
        this.customerList = res.data.records;
      }
    });
  },
  getsenderInforma() {
    const param = {
      pageNumber: 1,
      pageSize: 9999999,
      params: {}
    };
    addressPage(param).then((res) => {
      if (res.status === 'OK') {
        this.senderInformationList = res.data.records;
      }
    });
  },
  handleSenderInformationId(val) {
    if (val) {
      console.log(val, 'valval');
      const obj = this.senderInformationList.find(item => item.id === val);
      this.senderInformationIdObj = {
        senderName: obj.name, // 发件人姓名
        senderCompany: obj.companyName, // 发件人公司
        senderMobile: obj.mobile, // 发件人手机
        senderStreet: obj.street, // 发件人街道
        senderHouseNumber: obj.houseNumber, // 发件人门牌号
        senderArea: obj.area, // 发件人区
        senderCity: obj.city, // 发件人城市
        senderState: obj.state, // 发件人州
        senderZipcode: obj.zipcode, // 发件人邮编
        senderComplement: obj.complement, // 地址补充
        senderTax: obj.cpf || obj.cnpj, // 发件人税号
        senderIeNumber: obj.ieNumber, // 州注册号
        senderAddress: obj.addressDetail, // 发件人地址
        senderPhone: obj.phone // 发件人电话
      };
      console.log(this.senderInformationIdObj, 'senderInformationIdObj');
    } else {
      this.senderInformationIdObj = {};
    }
  },
  clickChageInfo() {
    if (this.selectionList.length === 0) {
      this.$message.warning(this.$t('GlobalSetObj.CheckForm'));
      return;
    }
    const statusArr = [1, 4];
    const waybillNumberList = [];
    if (this.selectionList.length === 1) {
      if (!statusArr.includes(this.selectionList[0].providerOrderStatus)) {
        this.$message.error(this.$t('customerManagements.tip101'));
        return;
      }
    }
    this.selectionList.forEach(item => {
      if (statusArr.includes(item.providerOrderStatus)) {
        waybillNumberList.push(item.waybillNumber);
      }
    });
    if (waybillNumberList.length === 0) {
      this.$message.error(this.$t('customerManagements.tip101'));
      return;
    }
    this.senderInformationDialog = true;
  },
  comfirmChange() {
    if (this.senderInformationId) {
      const statusArr = [1, 4];
      const ordersId = [];
      this.selectionList.forEach(item => {
        if (statusArr.includes(item.providerOrderStatus)) {
          ordersId.push(item.id);
        }
      });
      const data = {
        orderIds: ordersId,
        senderInfo: this.senderInformationIdObj
      };
      updatebatchAddress(data).then(res => {
        if (res.status === 'OK') {
          this.getSearch();
          this.senderInformationDialog = false;
          this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
        }
      });
    } else {
      this.$message.warning(this.$t('customerManagements.tip102'));
    }
  },
  getProviderList() {
    getStartupProviderChannel().then((res) => {
      if (res.status === 'OK') {
        this.provideNameList = res.data;
      }
    });
  },
  allExportOrder() {
    if (!this.queryForm.params.searchNumberStr && this.queryForm.params.providerOrderStatus !== 4) {
      if (!this.timeValue || this.timeValue.length === 0) {
        this.$message.warning(this.$t('collectionCenter.PleaseSelectTime'));
        return;
      }
    }
    if (this.queryForm.params.providerOrderStatus === 4) {
      this.exportParam.params.providerOrderStatus = this.queryForm.params.providerOrderStatus;
    }
    providerorderpageExpage(this.exportParam).then((res) => {
      if (res.status === 'OK') {
        goResourceTaskList();
      }
    });
  },
  downloadTheMenu() {
    console.log(this.downloadArr, ' this.downloadArr');
    this.downloadArr = [];
    if (this.selectionList.length === 0) {
      this.$message.warning(this.$i18n.t('orderCenterCont.PleaseSelectTheWaybill')); // 请选择运单
      return;
    }
    if (this.selectionList.length > 200) {
      this.$message.warning(
        this.$i18n.t('orderCenterCont.TheNumberOfSelectedPolygonsExceedsTheMaximumLimit200')
      ); // 选中面单数超出最大限制：200
      return;
    }
    this.selectionList.forEach(item => {
      if (item.labelUrl) {
        this.downloadArr.push(item.labelUrl);
      }
    });
    if (this.downloadArr.length === 0) {
      this.$message.warning(this.$t('navbar.tip01')); // 暂无需要下载的服务商标签
      return;
    }
    // 手动显示加载中动画
    const loading = this.$loading({
      fullscreen: true,
      lock: true,
      spinner: 'el-icon-loading',
      text: this.$i18n.t('orderCenterCont.DesperatelyLoading'), // '拼命加载中',
      background: 'rgba(250, 250, 250, 0.6)'
    });
    batchPdfDownload(this.downloadArr)
      .then((res) => {
        const dateType = setDateTime2();
        const saveName = `${dateType}` + this.$i18n.t('orderCenterCont.FaceSheet');
        saveAs(res, saveName);
      })
      .finally(() => {
        this.$refs.anjunTable.toggleSelection();
        loading.close();
      });
  },
  operationTableDialog() {
    this.isoperationTable = true;
  },
  operationTable() {
    const tableTh = [];
    this.bindTableColumns.forEach((item) => {
      if (this.tableHeaderForm.tableHeaderList.includes(item.label)) {
        tableTh.push(item);
      }
    });
    this.tableHeaderList = tableTh;
    this.isoperationTable = false;
  },
  resetTable() {
    this.tableHeaderForm.tableHeaderList = tableHeaderForm;
    this.tableHeaderList = headerList;
    this.isoperationTable = false;
    window.location.reload();
  }
};
